import { css } from 'styled-components';
import { ColorClubMatas1, ColorNeutralWhite, FontSize12 } from 'autogen/design-tokens/tokens';

const chanelTheme = {
    LabelContainer: css`
        display: none;
    `,
    StyledPriceModule: css`
        display: none;
    `,
    StyledProductName: css`
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        font-size: ${FontSize12};
    `,
    ProductTitle: css`
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        font-size: ${FontSize12};
        font-weight: normal;
    `,
    BrandTitle: css`
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        font-size: ${FontSize12};
        font-weight: bold;
    `,
    RatingContainer: css`
        display: none;
    `,
    ProductMiscellaneousTitle: css`
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        font-size: ${FontSize12};
        font-weight: bold;
    `,
    ButtonStyling: css<{ isFavorite: boolean; variant: string }>`
        border-radius: 0;
        font-weight: normal;

        ${({ variant, isFavorite }) =>
            variant !== 'primaryText' &&
            css`
                background: #000000;
                color: #fff;

                &:hover,
                &:focus {
                    background: #000000;
                    color: #fff;
                }

                & svg {
                    stroke: ${isFavorite ? ColorClubMatas1 : ColorNeutralWhite};
                }
            `};
    `,
    ProductCard: css`
        border: none;
        min-height: 350px;
    `,
    TagSplash: css`
        border-radius: 0;
        background-color: #000;
        color: #fff;
        text-transform: uppercase;
    `
};

export default chanelTheme;
